import Modal from 'react-modal';
import { IBankAccountViewModel } from 'viewModels';
import { CardAccounts } from '../../Cards/CardAccounts';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  selectedAccount?: IBankAccountViewModel;
}
export function ModalViewAccount({ selectedAccount, isOpen, onRequestClose }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-view-accounts-modal-content">
      <CardAccounts type="bank" bankAccountSelected={selectedAccount} />
    </Modal>
  );
}
